
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Taskpages from './pages/Taskpages';
import AllTaskpage from './pages/AllTaskpage';
import Setting from './pages/Setting';
import LoginPage from './components/LoginPage';
import UserLoginPage from './Userpages/UserLogin';
import DashBoard from './Userpages/DashBoard';
import DoneList from './Userpages/DoneList';
import UserTask from './Userpages/UserTask';
import ProjectList from './Userpages/ProjectList';
import CompleteTask from './pages/CompleteTask';
import AssignBy from './Userpages/AssignBy';
import UserStats from './pages/UserStats';

function App() {
  return (
    <Router>
  <Routes>
      
    
    <Route path="/" element={<Home />} />
    <Route path="/:projectId" element={<Taskpages />} />
    <Route path="/alltask" element={<AllTaskpage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/completetask" element={<CompleteTask />} />
    <Route path="/setting" element={<Setting />} />
    <Route path="/userstats" element={<UserStats />} />
    

    {/* User Pages */}
    <Route path="/userlogin" element={<UserLoginPage />} />
    <Route path="/dashboard" element={<DashBoard />} />
    <Route path="/donelist" element={<DoneList />} />
    <Route path="/tasks" element={<UserTask />} />
    <Route path="/projects" element={<ProjectList />} />
    <Route path="/assignbyme" element={<AssignBy />} />


    {/* Not Found Route */}
    
  </Routes>
</Router>

  );
}

export default App;